import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "asc-admin-jwt";
const USER_KEY = "asc-admin-user";

export function getToken() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(USER_KEY);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}

export function setSession(token, user) {
  window.localStorage.setItem(TOKEN_KEY, token);
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
}

export const authApi = axios.create({ baseURL: API });
authApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
authApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearSession();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/reset-password") && !window.location.pathname.startsWith("/admin/forgot-password")) {
        // soft redirect via reload to login
        if (window.location.pathname.startsWith("/admin")) {
          window.location.href = "/admin";
        }
      }
    }
    return Promise.reject(err);
  }
);

export async function login(email, password) {
  const { data } = await authApi.post("/auth/login", { email, password });
  setSession(data.access_token, data.user);
  return data.user;
}

export async function fetchMe() {
  const { data } = await authApi.get("/auth/me");
  return data;
}

export async function changePassword(current_password, new_password) {
  return (await authApi.post("/auth/change-password", { current_password, new_password })).data;
}

export async function forgotPassword(email) {
  return (await axios.post(`${API}/auth/forgot-password`, { email })).data;
}

export async function resetPassword(token, new_password) {
  return (await axios.post(`${API}/auth/reset-password`, { token, new_password })).data;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
